import { Component, Input, OnInit } from '@angular/core';
export interface Options {
  icon: string;
  iconWidth: number;
  iconHeight: number;
  textColor: string;
  iconColor: string;
  backgroundColor: string;
  textDecoration: string;
  margin: string;
  style: any;
}
export interface InfoOption extends Partial<Options> {}
@Component({
    selector: 'info',
    templateUrl: './info.component.html',
    styleUrls: ['./info.component.scss'],
    standalone: false
})
export class InfoComponent implements OnInit {
  @Input() option: InfoOption;

  constructor() {}

  ngOnInit() {
    const optionInit = {
      iconWidth: 24,
      iconHeight: 24,
      textColor: 'var(--info-font-color)',
      iconColor: 'var(--info-font-color)',
      backgroundColor: 'var(--info-bg-color)',
      textDecoration: 'none',
      margin: ' 40px 0px',
      style: {},
    };
    this.option = { ...optionInit, ...this.option };
  }
}
